import { render, staticRenderFns } from "./LevelSelection.vue?vue&type=template&id=214df57a&"
import script from "./LevelSelection.vue?vue&type=script&lang=js&"
export * from "./LevelSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports